<template>
  <div class="support-page">
    <header-bar></header-bar>

    <!-- 页头横幅 -->
    <section class="banner">
      <img
        class="banner-bg"
        :src="require('@/assets/banner_neural.jpg')"
        alt="般意品牌蓝色神经网络背景"
      />
      <div class="banner-mask"></div>
      <div class="banner-content">
        <h1 class="banner-title">支持与常见问题</h1>
        <p class="banner-subtitle">关于般意精力舱，你想知道的都在这里</p>
      </div>
    </section>

    <!-- 常见问题（全部展开渲染，便于检索与抓取） -->
    <section class="section faq-section">
      <h2 class="section-title">常见问题</h2>
      <div class="faq-list">
        <div class="faq-item" v-for="(item, index) in faq" :key="index">
          <div class="faq-q-row">
            <span class="faq-no">{{ ("0" + (index + 1)).slice(-2) }}</span>
            <h3 class="faq-q">{{ item.q }}</h3>
          </div>
          <p class="faq-a">{{ item.a }}</p>
        </div>
      </div>
    </section>

    <!-- 禁忌人群 -->
    <section class="section safety-section">
      <div class="safety-card">
        <div class="safety-head">
          <span class="safety-badge">!</span>
          <h2 class="safety-title">以下人群请勿使用</h2>
        </div>
        <ul class="safety-list">
          <li v-for="(item, index) in safety.contraindications" :key="index">
            {{ item }}
          </li>
        </ul>
        <p class="safety-advice">{{ safety.advice }}</p>
      </div>
    </section>

    <!-- 售后政策 -->
    <section class="section policy-section">
      <h2 class="section-title">售后政策</h2>
      <div class="policy-grid">
        <div
          class="policy-item"
          v-for="(item, index) in purchase.afterSale"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <p class="policy-antifake">{{ purchase.antiFake }}</p>
      <router-link class="policy-link" to="/buy">购买指引 →</router-link>
    </section>

    <!-- 联系我们 -->
    <section class="section contact-section">
      <h2 class="section-title">联系我们</h2>
      <div class="contact-wrap">
        <div class="contact-info">
          <div class="contact-item">
            <p class="contact-label">官方热线</p>
            <p class="contact-value">{{ contact.phone }}</p>
          </div>
          <div class="contact-item">
            <p class="contact-label">商务合作</p>
            <a class="contact-value link" :href="'mailto:' + contact.bdEmail">{{
              contact.bdEmail
            }}</a>
          </div>
          <div class="contact-item">
            <p class="contact-label">公司全称</p>
            <p class="contact-value">{{ company.fullName }}</p>
          </div>
        </div>
        <div class="contact-qr">
          <img :src="wechatQr" alt="般意微信公众号二维码" />
          <p>扫码关注微信公众号：{{ contact.wechatName }}</p>
        </div>
      </div>
    </section>

    <footer-info></footer-info>
  </div>
</template>

<script>
import headerBar from "@/components/common/HeaderBar";
import footerInfo from "@/components/common/FooterInfo";
import wechatQr from "@/assets/wechat_qrcode.png";
import { purchase, contact, faq, safety, company } from "@/data/facts";

export default {
  components: {
    headerBar,
    footerInfo,
  },
  data() {
    return {
      purchase,
      contact,
      faq,
      safety,
      company,
      wechatQr,
    };
  },
};
</script>

<style scoped>
.support-page {
  width: 100vw;
  background: #ffffff;
}

/* 页头横幅 */
.banner {
  position: relative;
  width: 100vw;
  height: 26vw;
  overflow: hidden;
}

.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(10, 12, 60, 0.6) 0%,
    rgba(27, 30, 138, 0.28) 60%,
    rgba(27, 30, 138, 0.12) 100%
  );
}

.banner-content {
  position: relative;
  padding: 8.6vw 13.3vw 0 13.3vw;
}

.banner-title {
  font-size: 2.5vw;
  color: #ffffff;
  font-family: "SourceHanSansCN-Bold";
}

.banner-subtitle {
  margin-top: 1.3vw;
  font-size: 1.25vw;
  color: rgba(255, 255, 255, 0.85);
  font-family: "SourceHanSansCN-Medium";
}

/* 通用区块 */
.section {
  padding: 4.2vw 13.3vw;
}

.section-title {
  text-align: center;
  font-size: 2.5vw;
  color: #333333;
  font-family: "SourceHanSansCN-Bold";
  margin-bottom: 3.2vw;
}

/* 常见问题 */
.faq-section {
  background: #ffffff;
}

.faq-list {
  max-width: 62vw;
  margin: 0 auto;
  border-top: 0.05vw solid #eeeeee;
}

.faq-item {
  border-bottom: 0.05vw solid #eeeeee;
  padding: 1.8vw 0;
}

.faq-q-row {
  display: flex;
  align-items: center;
}

.faq-no {
  flex-shrink: 0;
  width: 1.9vw;
  height: 1.9vw;
  margin-right: 1vw;
  background: #888ef9;
  border-radius: 0.4vw;
  color: #ffffff;
  font-size: 0.9vw;
  line-height: 1.9vw;
  text-align: center;
  font-family: "SourceHanSansCN-Bold";
}

.faq-q {
  font-size: 1.15vw;
  color: #333333;
  font-family: "SourceHanSansCN-Bold";
  line-height: 1.7;
}

.faq-a {
  margin-top: 0.9vw;
  padding-left: 2.9vw;
  font-size: 0.95vw;
  color: #666666;
  font-family: "SourceHanSansCN-Regular";
  line-height: 1.9;
}

/* 禁忌人群 */
.safety-section {
  background: #ffffff;
  padding-top: 0;
}

.safety-card {
  background: #fdf3f3;
  border-left: 0.45vw solid #c0392b;
  border-radius: 0.8vw;
  padding: 2.5vw 3vw;
}

.safety-head {
  display: flex;
  align-items: center;
}

.safety-badge {
  flex-shrink: 0;
  width: 1.9vw;
  height: 1.9vw;
  margin-right: 0.9vw;
  background: #c0392b;
  border-radius: 50%;
  color: #ffffff;
  font-size: 1.1vw;
  line-height: 1.9vw;
  text-align: center;
  font-family: "SourceHanSansCN-Bold";
}

.safety-title {
  font-size: 1.4vw;
  color: #c0392b;
  font-family: "SourceHanSansCN-Bold";
}

.safety-list {
  margin-top: 1.4vw;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

.safety-list li {
  width: 50%;
  font-size: 0.95vw;
  color: #333333;
  font-family: "SourceHanSansCN-Regular";
  line-height: 2.2;
  list-style: none;
}

.safety-list li::before {
  content: "•";
  color: #c0392b;
  margin-right: 0.5vw;
}

.safety-advice {
  margin-top: 1.5vw;
  padding-top: 1.5vw;
  border-top: 0.05vw solid #f0d5d5;
  font-size: 0.95vw;
  color: #c0392b;
  font-family: "SourceHanSansCN-Regular";
  line-height: 1.8;
}

/* 售后政策 */
.policy-section {
  background: #f7f8fa;
}

.policy-grid {
  display: flex;
  justify-content: space-between;
}

.policy-item {
  width: 17vw;
  background: #ffffff;
  border-radius: 0.8vw;
  border-top: 0.3vw solid #888ef9;
  padding: 1.8vw 1vw;
  text-align: center;
  font-size: 1vw;
  color: #1b1e8a;
  font-family: "SourceHanSansCN-Medium";
  box-sizing: border-box;
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.05);
}

.policy-antifake {
  margin-top: 2.2vw;
  text-align: center;
  font-size: 0.95vw;
  color: #666666;
  font-family: "SourceHanSansCN-Regular";
  line-height: 1.8;
}

.policy-link {
  display: block;
  width: 10vw;
  margin: 1.4vw auto 0 auto;
  text-align: center;
  font-size: 0.95vw;
  color: #ffffff;
  background: #1b1e8a;
  border-radius: 2vw;
  padding: 0.7vw 0;
  font-family: "SourceHanSansCN-Medium";
  text-decoration: none;
}

/* 联系我们 */
.contact-section {
  background: #ffffff;
}

.contact-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contact-item {
  margin-bottom: 1.8vw;
}

.contact-label {
  font-size: 0.85vw;
  color: #999999;
  font-family: "SourceHanSansCN-Regular";
}

.contact-value {
  margin-top: 0.4vw;
  font-size: 1.15vw;
  color: #333333;
  font-family: "SourceHanSansCN-Medium";
}

.contact-value.link {
  color: #1b1e8a;
  text-decoration: none;
}

.contact-qr {
  text-align: center;
  background: #ffffff;
  border: 0.05vw solid #e8e9f5;
  border-radius: 1vw;
  padding: 2vw 3vw;
  box-shadow: 0 0.6vw 2.2vw rgba(27, 30, 138, 0.12);
}

.contact-qr img {
  width: 9vw;
  height: 9vw;
  border-radius: 0.4vw;
}

.contact-qr p {
  margin-top: 1vw;
  font-size: 0.85vw;
  color: #666666;
  font-family: "SourceHanSansCN-Regular";
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Support.vue